import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CTASection: React.FC = () => {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-primary via-primary/90 to-secondary">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-8">
          <Icon name="Handshake" size={64} className="text-white mx-auto mb-6" />
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Upgrade Your Video Intelligence?
          </h2>
          <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Join leading organizations using camlytix AI to monitor operations, detect risks, and optimize performance. Begin your journey today.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          {/* <Button
            variant="default"
            size="lg"
            className="bg-white text-primary hover:bg-white/90 shadow-lg"
            iconName="UserPlus"
            iconPosition="left"
          >
            Apply for Partnership
          </Button> */}
          <Button
            variant="outline"
            size="lg"
            className="border-white text-white hover:bg-white/10"
            iconName="Calendar"
            iconPosition="left"
          >
            Schedule Consultation
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
            <Icon name="Clock" size={32} className="text-white mx-auto mb-3" />
            <h3 className="text-white font-semibold mb-2">Quick Onboarding</h3>
            <p className="text-white/80 text-sm">Get started in less than 24 hours</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
            <Icon name="Shield" size={32} className="text-white mx-auto mb-3" />
            <h3 className="text-white font-semibold mb-2">Enterprise Security</h3>
            <p className="text-white/80 text-sm">Bank-grade security standards</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
            <Icon name="TrendingUp" size={32} className="text-white mx-auto mb-3" />
            <h3 className="text-white font-semibold mb-2">Growth Support</h3>
            <p className="text-white/80 text-sm">Dedicated success managers</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;